import { useEffect } from "react";
import { isGroupAccessBlocked } from "../lib/api";

/**
 * Calls onBlockedAccess once any of the passed query errors indicates that
 * access to the current group is blocked (403 group_blocked).
 */
export function useBlockedAccessGuard(errors: unknown[], onBlockedAccess?: () => void) {
  const blocked = errors.some((error) => isGroupAccessBlocked(error));
  useEffect(() => {
    if (blocked) onBlockedAccess?.();
  }, [blocked, onBlockedAccess]);
}
